import { RegistrationState } from '../registration.interface';
import { api } from '../../../App';
import { fromRegistrationToGenerated } from '../../../parsers/to-generated/registration.parser';
import { RequestType } from '../../../model/enums/RequestType';

export const register = async (data: RegistrationState, requestType: RequestType): Promise<string | undefined> => {
  console.log('Making registration with current state: ', data);

  let registrationDto = fromRegistrationToGenerated(data, requestType);

  let response;
  if (requestType === RequestType.DoctorRegistration) {
    response = await api.submission.apiSubmissionsDoctorPost(registrationDto);
  } else {
    response = await api.submission.apiSubmissionsPatientPost(registrationDto);
  }

  return response?.data.id;
};
